import { render, staticRenderFns } from "./CallSidebar.vue?vue&type=template&id=b05fe222&scoped=true&"
import script from "./CallSidebar.vue?vue&type=script&lang=js&"
export * from "./CallSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CallSidebar.vue?vue&type=style&index=0&id=b05fe222&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05fe222",
  null
  
)

export default component.exports